import React from 'react'

export interface BrandLogoProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: string
  tagline?: boolean
  subtitle?: string
}

export const BrandLogo: React.FC<BrandLogoProps> = ({
  size = '180px',
  tagline = false,
  subtitle = 'LOCAL-FIRST MEDIA STUDIO',
  className = '',
  style = {},
  ...rest
}) => {
  return (
    <span
      role="img"
      aria-label="Nítido. Local-first Media Studio"
      className={className}
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        ...style,
      }}
      {...rest}
    >
      <svg
        viewBox="0 0 280 56"
        aria-hidden="true"
        focusable="false"
        style={{ display: 'block', width: size, height: 'auto' }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <text
          x="2"
          y="42"
          fontFamily="var(--font-display, 'Unbounded', sans-serif)"
          fontSize="44"
          fontWeight="800"
          letterSpacing="-1"
          fill="#ffffff"
        >
          Nítido<tspan fill="var(--c-accent-electric, #38BFFF)">.</tspan>
        </text>
      </svg>
      {tagline && (
        <span
          style={{
            fontFamily: "var(--font-display, 'Unbounded', sans-serif)",
            fontSize: '9.5px',
            fontWeight: 600,
            letterSpacing: '0.22em',
            color: 'rgba(255, 255, 255, 0.45)',
            textTransform: 'uppercase',
            marginTop: '-4px',
            paddingLeft: '4px',
          }}
        >
          {subtitle}
        </span>
      )}
    </span>
  )
}
